import { useEffect, useState } from 'react'
import CicloEntregaAcoesHttp from '../../../../../services/api/https/deliveries/ciclo-entrega-acoes.http'
import { errorHandler } from '../../../../../services/util/error.service'
import { gerarArquivoExcel } from '../../../../../services/util/excel.service'

export const EXPORT_PROGRAMACAO_EXCEL_ACTIONS = {
  LOADING_DELIVERY_ITEMS: 'LOADING_DELIVERY_ITEMS',
  EXPORTANDO_PROGRAMACAO: 'EXPORTANDO_PROGRAMACAO',
  NONE: 'NONE',
}
const INITIAL_STATE = {
  delivery_items: [],
  errorMessage: null,
  successMessage: null,
  loading: EXPORT_PROGRAMACAO_EXCEL_ACTIONS.LOADING_DELIVERY_ITEMS,
}

export default function useExportProgramacaoExcel(ciclo) {
  const [state, setState] = useState(INITIAL_STATE)

  useEffect(() => {
    async function fetchProgramacaoEntrega() {
      try {
        const items = await CicloEntregaAcoesHttp.getProgramacaoEntrega(ciclo.id)
        setState({
          ...state,
          loading: EXPORT_PROGRAMACAO_EXCEL_ACTIONS.NONE,
          delivery_items: items,
        })
      } catch (error) {
        setState({
          ...state,
          loading: EXPORT_PROGRAMACAO_EXCEL_ACTIONS.NONE,
          errorMessage: errorHandler(error),
        })
      }
    }
    ciclo.id && !Number.isNaN(ciclo.id) && fetchProgramacaoEntrega()
  }, [ciclo.id])

  // Actions
  const actions = {
    onBtnExportarClick() {
      setState({ ...state, loading: EXPORT_PROGRAMACAO_EXCEL_ACTIONS.EXPORTANDO_PROGRAMACAO })
      if (state.delivery_items.length === 0) {
        setState({
          ...state,
          errorMessage: 'Não existe programação para ser exportada',
          loading: EXPORT_PROGRAMACAO_EXCEL_ACTIONS.NONE,
        })
      } else {
        exportarProgramacao()
        setState({
          ...state,
          successMessage: 'Exportação realizada com sucesso',
          loading: EXPORT_PROGRAMACAO_EXCEL_ACTIONS.NONE,
        })
      }
    },
    resetMessages() {
      setState({ ...state, errorMessage: null, successMessage: null })
    },
  }

  // Helpers
  function exportarProgramacao() {
    const { company_name, data_importacao } = state.delivery_items[0]
    const fileName = `programacao_${company_name}_importada_em_${data_importacao.replace('/', '_')}.xlsx`
    const rows = [
      [
        'CLIENTE COLOG',
        'CNPJ COLOG',
        'NOME FANTASIA',
        'CNPJ',
        'NOTA',
        'SKU',
        'DESCRIÇÃO',
        'CAIXA/FARDO',
        'Peso Liquido',
        'UF',
        'CIDADE',
        'CD / TP / DISTRIBUIDOR',
        'LOTE',
        'PEDIDO',
      ],
    ]

    state.delivery_items.forEach(item => {
      const {
        company_name,
        cnpj_emissor,
        nome_fantasia,
        cnpj,
        nota_fiscal,
        produto_codigo,
        produto_nome,
        qte,
        peso,
        uf,
        cidade,
        tp_nome,
        lote,
        identificador,
      } = item
      rows.push([
        company_name,
        cnpj_emissor,
        nome_fantasia,
        cnpj,
        nota_fiscal,
        produto_codigo,
        produto_nome,
        qte,
        peso,
        uf,
        cidade,
        tp_nome.toUpperCase(),
        lote,
        identificador,
      ])
    })
    gerarArquivoExcel('programacao_entrega', rows, fileName)
  }

  return { state, actions }
}
